import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuditService } from 'src/app/services/audit.service';
import { AuditStatusService } from 'src/app/services/Auditstatus.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ConfigService } from 'src/app/services/auth/config.service';
import { FinalChecklistService } from 'src/app/services/finalchecklist.service';
import { ToastService } from 'src/app/toast/toast.service';

@Component({
  selector: 'app-checklist-status-modal',
  templateUrl: './checklist-status-modal.component.html',
  styleUrls: ['./checklist-status-modal.component.scss']
})
export class ChecklistStatusModalComponent implements OnInit {
  Statusform: FormGroup | any;
  roleid:any;
  iSocietyDetailsTransId:any;
  iSocietyDetailsId: any;
  statusid: any;
   ddlStatus:any;

  roleList = [
    { id: 1, name: 'Auditor' },
    { id: 2, name: 'Scrutiny' },
    { id: 3, name: 'AR' },
  ];

  roleFilterList: any[] = [];

  constructor(
    private fb: FormBuilder,
    private modalService: NgbModal,
    private finalChecklist: FinalChecklistService,
    private router: Router,
    private auditStatusService: AuditStatusService,
    private route: ActivatedRoute,
    private toastService: ToastService,
    private auditService: AuditService,
    private authService: AuthService,
    private config: ConfigService
  ) {}

  ngOnInit(): void {
    this.roleid = this.authService.currentUserValue.roleId;
    this.statusid = this.auditStatusService.getStatus();

    this.route.paramMap.subscribe((params) => {
      const transId = params.get('iSocietyDetailsTransId');
      this.iSocietyDetailsTransId = transId ? +transId : 0;

      const id = params.get('iSocietyDetailsId');
      this.iSocietyDetailsId = id ? +id : null;

      this.setRoleFilterList();
    });
  }
  CreateStatusform() {
      this.Statusform = this.fb.group({
        ddlStatus: [0, Validators.required],
        iSocietyDetailsID: ['', Validators.required],
        DepartmentalRemarkDocument: [''],
        iAllotAuditorID: ['', Validators.required],
  
        DepartmentalRemarkFileName: ['', Validators.required],
        transid: ['', Validators.required],
      });
    }

  
  private setRoleFilterList(): void {
    const specialRoleIds = [10, 11, 12, 18, 19];

    if (this.statusid === 0 && this.roleid === 13) {
      this.roleFilterList = this.roleList.filter(x => x.id === 1); // Only Auditor
    }
    else if (this.statusid === 2 && this.roleid === 13) {
      this.roleFilterList = this.roleList.filter(x => x.id === 1); // Only Auditor
    }
    else if ((this.statusid === 0 || this.statusid === 4) && specialRoleIds.includes(this.roleid)) {
      this.roleFilterList = this.roleList.filter(x => x.id !== 3); // Exclude AR
    }
    else if (this.statusid === 7 && this.roleid === 13) {
      this.roleFilterList = [...this.roleList]; // All roles
    }
    // Default to empty if no match
    else {
      this.roleFilterList = [];
    }
  }

    onSubmitRemark(): void {

    const payload: any = {
      transId: this.iSocietyDetailsTransId,
      statusAction: this.ddlStatus,
     // scrutinyRemark: this.DepUpload.sDepartmentalRemark,
      //arRemark: this.ARnewUpload.sDepartmentalRemark,
     // arUploadFile: this.ARnewUpload.DepartmentalRemarkDocument
    };

  }
}

  

